import { useState } from 'react';
import classNames from 'classnames';
import type { AppGarageReview } from '$page-router/api/getGaragesByLatLong';

import styles from '../../index.module.scss';

interface ReviewQuoteProps {
  readonly text: AppGarageReview['text'];
  readonly authorName: AppGarageReview['authorName'];
  readonly relativeTime: AppGarageReview['relativeTime'];
}

export function ReviewQuote({ text, authorName, relativeTime }: ReviewQuoteProps): JSX.Element | null {
  const [showMore, setShowMore] = useState(false);

  if (!text) return null;

  return (
    <>
      <q
        className={classNames(styles.ReviewText, !showMore && styles.Hidden, 'ReviewText')}
        tabIndex={0}
        role="button"
        onClick={() => {
          setShowMore(!showMore);
        }}
        onKeyDown={() => setShowMore(!showMore)}
      >
        {text}
      </q>
      <div className={classNames(styles.ReviewAuthor, 'ReviewAuthor')}>
        {authorName} &mdash; {relativeTime}
      </div>
    </>
  );
}
